import { render } from "./ServiceIncluded.vue?vue&type=template&id=7f657070&lang=pug"
import script from "./ServiceIncluded.vue?vue&type=script&lang=js"
export * from "./ServiceIncluded.vue?vue&type=script&lang=js"

import "./ServiceIncluded.vue?vue&type=style&index=0&id=7f657070&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__